import React, { FC } from 'react';
import { Loader } from './Loader';
import styles from './loader_with_text.module.scss';

export const LoaderWithText: FC = ({ children }) => (
  <div className={styles.container}>
    <Loader />
    <span className={styles.text}>{children}</span>
  </div>
);
